<!--文本类型组件-->
<template>
  <div class="text-wrap">
    <ul>
      <li
        v-for="(item, index) in config.textRow"
        :key="index"
        :style="{
          marginLeft: config.offsetX + 'px',
          marginTop: config.offsetY + 'px'
        }"
      >
        <span
          class="label"
          :style="{
            minWidth: config.text.minWidth + 'px',
            fontSize: item.tSize + 'px',
            color: item.tColor
          }"
        >{{ item['label'] }}</span>
        <span
          class="value"
          :class="[config.value.isOverflow ? 'valueSpace' : '']"
          :style="{
            fontSize: item.vSize+ 'px',
            color: item.vColor
          }"
        >{{ chartData[0][item['value']] }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    chartData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  name: 'TextC'
}
</script>

<style lang="stylus" scoped>
.text-wrap
  li
    display flex
    align-items center
    margin-bottom 10px
    min-height 22px
    line-height 22px
    .value
      flex 1
    .valueSpace
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
</style>
